<mat-chip-list class="chip-list">
  <mat-chip *ngFor="let item of items" disableRipple>
    {{ displayProperty ? item[displayProperty] : item }}
  </mat-chip>
</mat-chip-list>
